var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDocExist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Unicargo Icons_file 2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 407",
    d: "M31.7773 3.80737H7.18936C6.68047 3.80737 6.271 4.21991 6.271 4.7288V33.7922C6.271 34.3011 6.68353 34.7136 7.19243 34.7136H10.9485C11.4574 34.7136 11.87 35.1262 11.87 35.6351V38.1594C11.87 38.6683 12.2825 39.0808 12.7914 39.0808H29.7363C29.9834 39.0808 30.2201 38.9816 30.3933 38.8054L36.4649 32.631C36.6344 32.4586 36.7293 32.2266 36.7293 31.9849V10.5517C36.7293 10.0428 36.3168 9.63029 35.8079 9.63029H33.6195C33.1106 9.63029 32.6981 9.21775 32.6981 8.70886V4.7288C32.6981 4.21991 32.2862 3.80737 31.7773 3.80737Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27441 33.625H13.0364",
    stroke: "#F4F6F6",
    strokeWidth: 2.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27466 4.90942V33.6248",
    stroke: "#F4F6F6",
    strokeWidth: 2.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5654 4.90942H7.27466",
    stroke: "#F4F6F6",
    strokeWidth: 2.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5647 10.6327V4.90942",
    stroke: "#F4F6F6",
    strokeWidth: 2.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.031 10.6414V10.6328V38.0883",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 2.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7221 10.6411H13.031",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 2.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.031 38.088H29.6935C32.0499 35.7316 33.3743 34.4115 35.7221 32.0637V10.6411",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.031 38.088H29.6935C32.0499 35.7316 33.3743 34.4115 35.7221 32.0637V10.6411",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 2.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_8",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6936 38.088V32.0422H35.7222",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 2.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_9",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1673 15.8315H16.5884",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 2.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_10",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1673 21.5198H16.5884",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 2.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_11",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9089 27.2046H16.5884",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 2.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_12",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9089 32.8984H16.5884",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 2.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDocExist);
export default __webpack_public_path__ + "static/media/no-doc-exist.73cd94d9f4a3a881553ea217f563562e.svg";
export { ForwardRef as ReactComponent };